import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import digital from "./digital.png";

const Digital = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Productos |Un paso digital adelante </title></Helmet>
      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>
          <h1>Tu primer paso hacia un negocio más inteligente</h1>
          <p className={classes['mb-1']}>
            <strong> Un paso digital adelante</strong> Es un refrescante
            <strong>sencillo, asequible y guiada.</strong>
           solución de transformación digital diseñada específicamente para pequeñas empresas.
            <strong>Somos tus compañia indicada para este  viaje digital.</strong> 
            Caminamos junto a usted, ayudándole a comprender exactamente cómo la tecnología puede solucionar esos dolores de cabeza 
            cotidianos y problemas simples que agotan su tiempo y energía.
          </p>
          <img src={digital} alt="Step Forward Digital" className={classes['img-tech']}/>
        </section>
        </main>
    </div>
  );
};

export default Digital;